(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-sale-plp-root][data-sale-collection-handle="sale"][data-ch-filter-count-owner="sale-root"]');
    var drawer = root && root.querySelector('[data-ch-sale-root-drawer]');
    if (!root || !drawer || drawer.getAttribute('data-ch-sale-root-ready') === 'true') return;
    drawer.setAttribute('data-ch-sale-root-ready', 'true');

    var panel = drawer.querySelector('.ch-sr__panel');
    var applyButton = drawer.querySelector('[data-ch-sale-root-apply]');
    var minInput = drawer.querySelector('[data-ch-sale-root-price-min]');
    var maxInput = drawer.querySelector('[data-ch-sale-root-price-max]');
    var collectionUrl = drawer.getAttribute('data-ch-sale-root-url') || '/collections/sale';
    var defaultSort = drawer.getAttribute('data-ch-sale-root-default-sort') || '';
    var minName = drawer.getAttribute('data-ch-sale-root-price-min-name') || '';
    var maxName = drawer.getAttribute('data-ch-sale-root-price-max-name') || '';
    var lastOpener = null;
    var inertRecords = [];
    var requestId = 0;
    var knownTotal = null;
    var state = readState(window.location.href);
    var draft = copyState(state);

    // --- Contrato transversal compartido por los cinco filtros propios
    //     (assets/chagual-filter-contract.js). Resolucion perezosa y tolerante:
    //     si esa capa no cargo, el filtro sigue operando igual que antes. ---
    function shared(name) {
      var api = window.ChagualFilterContract;
      var fn = api && api[name];
      return typeof fn === 'function' ? fn : function () {};
    }

    function appliedFacets() {
      var facets = [];
      if (state.min || state.max) facets.push({ facet: 'precio', value: (state.min || '0') + '-' + (state.max || 'max') });
      if (state.sort && state.sort !== defaultSort) facets.push({ facet: 'orden', value: state.sort });
      return facets;
    }

    function copyState(value) {
      return { sort: value.sort, min: value.min, max: value.max };
    }

    function readState(href) {
      var url = new URL(href, window.location.origin);
      return {
        sort: url.searchParams.get('sort_by') || defaultSort,
        min: minName ? (url.searchParams.get(minName) || '') : '',
        max: maxName ? (url.searchParams.get(maxName) || '') : ''
      };
    }

    function cleanNumber(value) {
      var number = parseFloat(String(value || '').replace(',', '.'));
      return isFinite(number) && number >= 0 ? String(number) : '';
    }

    function normalizedDraft() {
      var value = copyState(draft);
      value.min = cleanNumber(value.min);
      value.max = cleanNumber(value.max);
      if (value.min && value.max && parseFloat(value.min) > parseFloat(value.max)) {
        var swap = value.min;
        value.min = value.max;
        value.max = swap;
      }
      return value;
    }

    function buildUrl(value, page) {
      var url = new URL(collectionUrl, window.location.origin);
      if (value.sort && value.sort !== defaultSort) url.searchParams.set('sort_by', value.sort);
      if (minName && value.min) url.searchParams.set(minName, value.min);
      if (maxName && value.max) url.searchParams.set(maxName, value.max);
      if (page && page > 1) url.searchParams.set('page', String(page));
      return url.pathname + (url.search ? url.search : '');
    }

    function resultsNode(scope) {
      if (scope && scope.matches && scope.matches('[data-ch-filter-results][data-ch-filter-owner="sale-root"]')) return scope;
      return (scope || document).querySelector('[data-ch-filter-results][data-ch-filter-owner="sale-root"]');
    }

    function resultsTotal(scope) {
      var results = resultsNode(scope);
      if (!results) return null;
      var total = parseInt(results.getAttribute('data-ch-filter-total'), 10);
      return isNaN(total) || total < 0 ? null : total;
    }

    function setGridCount(total) {
      var count = root.querySelector('[data-sale-grid-count]');
      var drawerTotal = drawer.querySelector('[data-ch-sale-root-total]');
      knownTotal = total;
      if (count) {
        count.setAttribute('data-ch-filter-count-current', String(total));
        count.textContent = total === 1 ? '1 producto' : total + ' productos';
      }
      if (drawerTotal) {
        drawerTotal.textContent = String(total);
        drawerTotal.hidden = false;
      }
      if (applyButton) applyButton.removeAttribute('aria-label');
    }

    function markDrawerTotalUnknown() {
      var drawerTotal = drawer.querySelector('[data-ch-sale-root-total]');
      if (drawerTotal) drawerTotal.hidden = true;
      if (applyButton) applyButton.setAttribute('aria-label', 'Ver resultados');
    }

    function restoreKnownDrawerTotal() {
      var drawerTotal = drawer.querySelector('[data-ch-sale-root-total]');
      if (knownTotal == null || !drawerTotal) return;
      drawerTotal.textContent = String(knownTotal);
      drawerTotal.hidden = false;
      if (applyButton) applyButton.removeAttribute('aria-label');
    }

    function syncOpeners(open) {
      document.querySelectorAll('[data-ch-sale-root-filter-open],[data-ch-sale-root-sort-open]').forEach(function (button) {
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    function renderDrawer() {
      drawer.querySelectorAll('[data-ch-sale-root-sort]').forEach(function (button) {
        var selected = button.getAttribute('data-ch-sale-root-sort') === draft.sort;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      if (minInput) minInput.value = draft.min;
      if (maxInput) maxInput.value = draft.max;
      // B9: una sola parada de tabulacion por grupo de botones de opcion.
      shared('refreshRoving')(drawer);
    }

    function renderActivePage() {
      var holder = root.querySelector('[data-ch-sale-root-active-page]');
      if (!holder) return;
      holder.textContent = '';
      if (state.min || state.max) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ch-sr-active-page__chip';
        button.setAttribute('data-ch-sale-root-remove-price', '');
        button.textContent = 'Precio: ' + (state.min ? '$' + state.min : 'mínimo') + ' – ' + (state.max ? '$' + state.max : 'máximo') + ' ×';
        holder.appendChild(button);
      }
      holder.hidden = holder.children.length === 0;
    }

    function emitCatalogUpdated(total, url) {
      document.dispatchEvent(new CustomEvent('chagual:catalog-updated', {
        detail: { owner: 'sale-root', total: total, url: url }
      }));
    }

    // --- Cambio de pagina accesible (hallazgo P1 numero 3 de la auditoria 16).
    //     Antes el swap reemplazaba el resultado y dejaba al cliente donde estaba,
    //     con el foco perdido y sin aviso. Ahora: anuncio en la region viva que
    //     sobrevive al swap, foco al inicio del resultado y vista controlada. ---
    function announceResults(page, pages, total) {
      var status = root.querySelector('[data-ch-filter-status]');
      if (!status) return;
      var message = total === 1 ? '1 producto' : total + ' productos';
      if (pages > 1 && page > 0) message = 'Página ' + page + ' de ' + pages + '. ' + message;
      status.textContent = message + '.';
    }

    function headerOffset() {
      if (typeof window.getComputedStyle !== 'function' || !document.documentElement) return 0;
      var raw = window.getComputedStyle(document.documentElement).getPropertyValue('--chagual-header-offset');
      var value = parseFloat(raw);
      return isFinite(value) && value > 0 ? value : 0;
    }

    function focusResultsStart(node) {
      if (!node) return;
      try { node.focus({ preventScroll: true }); } catch (error) { node.focus(); }
      if (typeof node.getBoundingClientRect !== 'function' || typeof window.scrollTo !== 'function') return;
      var top = node.getBoundingClientRect().top + (window.pageYOffset || 0) - headerOffset() - 8;
      window.scrollTo(0, top > 0 ? top : 0);
    }

    // `action` describe que hizo la persona: alimenta la medicion compartida
    // (auditoria 24, huecos 1, 2, 3 y 5) sin cambiar el flujo del swap. Sin
    // `action` explicito es restauracion de historial y no se mide.
    function swapResults(url, pushHistory, returnFocus, action) {
      var intent = action || 'history';
      var live = resultsNode(root);
      if (!live || typeof fetch !== 'function') {
        shared('trackFallback')('sale-root', 'sin-fetch', url);
        window.location.assign(url);
        return;
      }
      var currentRequest = ++requestId;
      shared('beginBusy')(root);
      fetch(url, { headers: { 'X-Requested-With': 'fetch' }, credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Respuesta inválida');
          return response.text();
        })
        .then(function (html) {
          if (currentRequest !== requestId) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshRoot = doc.querySelector('[data-sale-plp-root][data-sale-collection-handle="sale"][data-ch-filter-count-owner="sale-root"]');
          var fresh = freshRoot && resultsNode(freshRoot);
          var total = resultsTotal(fresh);
          var freshPage = fresh ? parseInt(fresh.getAttribute('data-ch-filter-page'), 10) : NaN;
          var expectedInfeedCount = freshPage === 1 && total > 0 ? 1 : 0;
          var infeedCount = fresh ? fresh.querySelectorAll('[data-sale-infeed-shell]').length : 0;
          live = resultsNode(root);
          if (!fresh || !live || total == null || isNaN(freshPage) || infeedCount !== expectedInfeedCount) { shared('trackFallback')('sale-root', 'respuesta-incompleta', url); window.location.assign(url); return; }
          if (!window.ChagualCollectionSeoSync || !window.ChagualCollectionSeoSync.apply(doc)) { shared('trackFallback')('sale-root', 'sin-seo-sync', url); window.location.assign(url); return; }
          var previousPage = parseInt(live.getAttribute('data-ch-filter-page'), 10);
          var freshPages = parseInt(fresh.getAttribute('data-ch-filter-pages'), 10);
          live.replaceWith(fresh);
          if (pushHistory !== false && window.history && window.history.pushState) {
            window.history.pushState({ chagualCatalog: 'sale-root' }, '', url);
          }
          setGridCount(total);
          renderActivePage();
          closeDrawer(returnFocus === true);
          announceResults(freshPage, freshPages, total);
          if (!isNaN(freshPage) && !isNaN(previousPage) && freshPage !== previousPage) focusResultsStart(fresh);
          emitCatalogUpdated(total, url);
          // Medicion compartida: faceta, valor y cantidad de resultados.
          if (intent === 'clear') shared('trackClear')('sale-root', total, url, 'drawer');
          else if (intent === 'apply') shared('trackApply')('sale-root', appliedFacets(), total, url);
        })
        .catch(function () {
          if (currentRequest === requestId) {
            shared('trackFallback')('sale-root', 'peticion-fallida', url);
            window.location.assign(url);
          }
        })
        // B10: la guarda de secuencia nacio aqui y ahora la presta el contrato
        // compartido a los otros cuatro controladores. Misma condicion de antes.
        .then(function () { shared('endBusy')(root, currentRequest === requestId); });
    }

    function markInert(element) {
      if (!element || element.nodeType !== 1) return;
      var record = { element: element, inert: false, aria: false };
      if (!element.hasAttribute('inert')) { element.setAttribute('inert', ''); record.inert = true; }
      if (!element.hasAttribute('aria-hidden')) { element.setAttribute('aria-hidden', 'true'); record.aria = true; }
      if (record.inert || record.aria) inertRecords.push(record);
    }

    function setBackgroundInert(on) {
      if (on) {
        var node = drawer;
        while (node && node.parentNode && node !== document.body) {
          Array.prototype.forEach.call(node.parentNode.children, function (sibling) {
            if (sibling !== node) markInert(sibling);
          });
          node = node.parentNode;
        }
      } else {
        inertRecords.forEach(function (record) {
          if (record.inert) record.element.removeAttribute('inert');
          if (record.aria) record.element.removeAttribute('aria-hidden');
        });
        inertRecords = [];
      }
    }

    function focusables() {
      return Array.prototype.slice.call(panel.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),[tabindex]:not([tabindex="-1"])'))
        .filter(function (element) { return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement; });
    }

    function openDrawer(opener, group) {
      lastOpener = opener || lastOpener;
      draft = copyState(state);
      renderDrawer();
      restoreKnownDrawerTotal();
      drawer.hidden = false;
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      document.body.classList.add('ch-sr-lock');
      setBackgroundInert(true);
      syncOpeners(true);
      var target = drawer.querySelector('[data-ch-sale-root-group="' + (group || 'categoria') + '"]');
      var first = target && target.querySelector('a[href],button,input');
      try { (first || panel).focus({ preventScroll: true }); } catch (error) { (first || panel).focus(); }
      if (target) target.scrollIntoView({ block: 'start' });
    }

    function closeDrawer(returnFocus) {
      var wasOpen = drawer.classList.contains('is-open');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.hidden = true;
      drawer.setAttribute('inert', '');
      document.body.classList.remove('ch-sr-lock');
      setBackgroundInert(false);
      syncOpeners(false);
      if (returnFocus !== false && wasOpen && lastOpener && typeof lastOpener.focus === 'function') lastOpener.focus();
    }

    document.addEventListener('click', function (event) {
      var filterOpen = event.target.closest && event.target.closest('[data-ch-sale-root-filter-open]');
      var sortOpen = event.target.closest && event.target.closest('[data-ch-sale-root-sort-open]');
      if (filterOpen || sortOpen) {
        event.preventDefault();
        openDrawer(filterOpen || sortOpen, sortOpen ? 'orden' : 'categoria');
        return;
      }
      var removePrice = event.target.closest && event.target.closest('[data-ch-sale-root-remove-price]');
      if (removePrice) {
        event.preventDefault();
        state.min = state.max = '';
        draft = copyState(state);
        renderActivePage();
        // B12: el chip pulsado desaparece; el foco pasa al chip siguiente y, si
        // no queda ninguno, al boton que abre el cajon. Patron copiado de
        // chagual-maceteros-filter.js a traves del contrato compartido.
        shared('focusAfterChipRemoval')(
          root.querySelector('[data-ch-sale-root-active-page]'),
          '[data-ch-sale-root-remove-price]',
          document.querySelector('[data-ch-sale-root-filter-open]')
        );
        swapResults(buildUrl(state), true, false, 'clear');
        return;
      }
      var pageLink = event.target.closest && event.target.closest('[data-ch-filter-results][data-ch-filter-owner="sale-root"] .ch-sr-pagination a');
      if (pageLink) {
        event.preventDefault();
        swapResults(pageLink.href, true, false);
      }
    });

    drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-ch-sale-root-close]')) { event.preventDefault(); closeDrawer(true); return; }
      var sort = event.target.closest('[data-ch-sale-root-sort]');
      if (sort) {
        event.preventDefault();
        draft.sort = sort.getAttribute('data-ch-sale-root-sort') || defaultSort;
        renderDrawer();
      }
    });

    drawer.addEventListener('input', function (event) {
      if (event.target === minInput) {
        draft.min = event.target.value;
        markDrawerTotalUnknown();
      }
      if (event.target === maxInput) {
        draft.max = event.target.value;
        markDrawerTotalUnknown();
      }
    });

    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Tab' && drawer.classList.contains('is-open')) {
        var items = focusables();
        if (!items.length) { event.preventDefault(); panel.focus(); return; }
        var first = items[0], last = items[items.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });

    // B9: el movimiento dentro de los grupos de botones de opcion pasa a la capa
    // compartida, que agrega Inicio y Fin, salta las opciones deshabilitadas y
    // deja una sola parada de tabulacion por grupo. Este owner solo aporta su
    // vocabulario de teclas y su estado.
    shared('bindRadioKeyboard')(drawer, function (next) {
      draft.sort = next.getAttribute('data-ch-sale-root-sort') || defaultSort;
      renderDrawer();
    }, ['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft']);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(true);
    });

    var clear = drawer.querySelector('[data-ch-sale-root-clear]');
    if (clear) clear.addEventListener('click', function (event) {
      event.preventDefault();
      state = { sort: defaultSort, min: '', max: '' };
      draft = copyState(state);
      renderDrawer();
      renderActivePage();
      swapResults(buildUrl(state), true, true, 'clear');
    });

    if (applyButton) applyButton.addEventListener('click', function (event) {
      event.preventDefault();
      state = normalizedDraft();
      draft = copyState(state);
      renderDrawer();
      renderActivePage();
      swapResults(buildUrl(state), true, true, 'apply');
    });

    window.addEventListener('popstate', function () {
      state = readState(window.location.href);
      draft = copyState(state);
      renderDrawer();
      renderActivePage();
      swapResults(window.location.href, false, false);
    });

    renderDrawer();
    renderActivePage();
    syncOpeners(false);
    var initialTotal = resultsTotal(root);
    if (initialTotal != null) setGridCount(initialTotal);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
